export const animations = {
  big: { spine: 'animations/spine/win/skeleton.json' },
  mega: { spine: 'animations/spine/win/skeleton.json' },
  ultra: { spine: 'animations/spine/win/skeleton.json' },
  bonusMultiplier: { spine: 'animations/spine/multiplier/skeleton.json' },
}

export const bonusMultiplierTime = 2.7
export const isNewBigWin = true
export const time = 2
export const winParticles = { mega: ['confetti'] }
